import moment from 'moment';

export class AlgemeneMelding {

  static deserialize(dto: AlgemeneMeldingDto): AlgemeneMelding {
    return new AlgemeneMelding(
      dto.id,
      dto.auteurId,
      dto.content,
      dto.actiefVanDag,
      dto.actiefTotDag,
      new Date(dto.creatieTijdstip),
      new Date(dto.laatstGewijzigdeTijdstip),
    );
  }

  static sortOudsteActiefVanDagEerst(a: AlgemeneMelding, b: AlgemeneMelding): number {
    return new Date(a.getActiefVanDag()).getTime() - new Date(b.getActiefVanDag()).getTime();
  }

  constructor(private id: string,
              private auteurId: string,
              private content: string,
              private actiefVanDag: string,
              private actiefTotDag: string,
              private creatieTijdstip: Date,
              private laatstGewijzigdeTijdstip: Date,
  ) {
  }

  isActief(): boolean {
    const vandaag = moment().format('YYYY-MM-DD');
    return vandaag >= this.getActiefVanDag() &&
      vandaag <= this.getActiefTotDag();
  }

  getId(): string {
    return this.id;
  }

  getAuteurId(): string {
    return this.auteurId;
  }

  getContent(): string {
    return this.content;
  }

  getActiefVanDag(): string {
    return this.actiefVanDag;
  }

  getActiefTotDag(): string {
    return this.actiefTotDag;
  }

  getCreatieTijdstip(): Date {
    return this.creatieTijdstip;
  }

  getLaatstGewijzigdeTijdstip(): Date {
    return this.laatstGewijzigdeTijdstip;
  }
}

export interface AlgemeneMeldingDto {
  id: string;
  auteurId: string;
  content: string;
  actiefVanDag: string;
  actiefTotDag: string;
  creatieTijdstip: string;
  laatstGewijzigdeTijdstip: string;
}
